export const ACCOUNT_NO = "glAccountNumber";
export const ACCOUNT_CATEGORY = "accountCategory";
export const SUBLEDGER = "subledger";
export const SUBLEDGER_TYPE = "subledgerType";
export const SHORT_DESC = "accountShortDesc";
export const LONG_DESC = "accountLongDesc";
export const COMMENT = "notes";
export const RECON_ACCOUNT = "reconAccount";
export const GROUP_GL = "groupDistributionGl";
export const PROFIT_CENTER = "profitCenter";
export const ORDER_NUMBER = "orderNumber";
export const COST_CENTER = "costCenter";
export const NO_DIRECT_POSTING = "noDirectPosting";
export const CLEARING_ACCOUNT = "clearingAccount";
export const VIRTUAL_ACC = "systemAccountCode";
export const ALTERNATE_ACC = "alternativeAccount";
export const ALTERNATE_ACC_CUSTOM = "alternativeAccountCustom";
export const OTHER_ALTERNATE_ACC = "OTHER";
